import * as React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
// import "react-datepicker/dist/react-datepicker.css";
import "./styles.css";
import { Route, Routes } from "react-router-dom";
import { MetaTagsGenerator } from "./features/meta-tags-generator/components/MetaTagsGenerator";
import HooksGenerators from "./features/meta-tags-generator/components/HooksGenerators";
import { HeaderTagsGenerator } from "./features/header-tags-generator";
import { SeoGradedContent } from "./features/seo-graded-content";
import { SeoWebsiteAudit } from "./features/seo-website-audit";
import { RewriteOptimizeContent } from "./features/rewrite-optimize-content";
import { Dashboard } from "./features/dashboard/dashboard";
import { FaqsGenerator } from "./features/faqs-generator";
import "bootstrap/dist/css/bootstrap.min.css";
import { SeoContentGraderAnalyzer } from "./features/seo-content-grader-analyzer/components/SeoContentGraderAnalyzer";
import KeywordDensityChecker from "./features/density-checker/KeywordDensityChecker";
import SocialHeadlinesGenerator from "./features/social-headlines-generator/SocialHeadlinesGenerator";
import HashtagGenerator from "./features/hashtag-generator/HashtagGenerator";
import BlogPostForm from "./features/blog-post-generator/components/BlogPostForm";
import OverviewPage from "./features/seo-website-audit/components/OverviewPage";
import JpgToPngConverter from "./features/jpg-to-png-converter";
import BrokenLinkChecker from "./features/broken-links";

import PasswordGenerator from "./features/password-generator";
import WordCounterTool from "./features/word-counter";
import RobotsValidator from "./features/robots";
import SerpPreviewSimulator from "./features/sero-preview-simulator";
import RedirectChecker from "./features/redirect-checker";
import RoasCalculator from "./features/roas";
import { DomainChecker } from "./features/domain-checker";
import { ColorPicker } from "./features/color-picker";
import { CpcCalculator } from "./features/cpc-calculator";
import CPMCalculator from "./features/cpm-calculator/CpmCalculator";
import { CRCCalculator } from "./features/crc-calculator";
import CtrCalculator from "./features/ctr-calculator/CtrCalculator";
import HeadingTagsChecker from "./features/heading-tags-checker/HeadingTagsChecker";
import ImageFormateConverter from "./features/image-format-converter/ImageFormatConverter";
import ImageOptimizer from "./features/image-optimizer/ImageOptimizer";
import ReverseImageSearch from "./features/reverse-image-search/ReverseImageSearch";
import HttpStatusTool from "./features/http-status-tool/HttpStatusTool";
import MarketingRoiCalculator from "./features/marketing-roi-calculator/MarketingRoiCalculator";
import PageSpeedChecker from "./features/page-speed-checker/PageSpeedChecker";
import ColorConverter from "./features/color-converter/ColorConverter";
import OutlineGenerator from "./features/outline-generator/OutlineGenerator";

import SitemapChecker from "./features/sitemap-checker";
import SitemapValidator from "./features/sitemap-validator";

import RobotsTxtGenerator from "./features/robots-txt-generator/RobotsTxtGenerator";
import WebsiteAuthorityChecker from "./features/website-authority-checker/WebsiteAuthorityChecker";
import BacklinkChecker from "./features/backlink-checker/BacklinkChecker";
import { Container } from "react-bootstrap";

// const getDefaultRouteElement = (): React.ReactNode => {
//   const text: string = window.location.href;

//   if (text.includes("hooks-generator")) return <HooksGenerators />;
//   if (text.includes("meta-tags-generator")) return <MetaTagsGenerator />;
//   if (text.includes("header-tags-generator")) return <HeaderTagsGenerator />;
//   if (text.includes("faqs-generator")) return <FaqsGenerator />;
//   if (text.includes("density-checker")) return <KeywordDensityChecker />;
//   if (text.includes("social-headlines-generator"))
//     return <SocialHeadlinesGenerator />;
//   if (text.includes("rewrite-optimize-content"))
//     return <RewriteOptimizeContent />;
//   if (text.includes("seo-graded-content-analyzer"))
//     return <SeoContentGraderAnalyzer />;
//   if (text.includes("seo-website-audit")) return <SeoWebsiteAudit />;
//   if (text.includes("hashtag-generator")) return <HashtagGenerator />;
//   if (text.includes("blog-generator")) return <BlogPostForm />;
//   if (text.includes("dashboard")) return <Dashboard />;
//   if (text.includes("social-headlines-generator"))
//     return <SocialHeadlinesGenerator />;
//   if (text.includes("site-map-checker")) return <SitemapChecker />;

//   return <Dashboard />;
// };
// import { IframeAwareRedirect } from "./IframeAwareRedirect";

const App: React.FC = () => {
  return (
    <Container>
      <>
        {/* <IframeAwareRedirect /> */}
        <Routes>
          <Route path="/*" element={<Dashboard />} />
          <Route
            path="/header-tags-generator"
            element={<HeaderTagsGenerator />}
          />
          <Route path="/seo-graded-content" element={<SeoGradedContent />} />
          <Route
            path="/seo-graded-content-analyzer"
            element={<SeoContentGraderAnalyzer />}
          />
          <Route path="/seo-website-audit">
            <Route index element={<SeoWebsiteAudit />} />
            <Route path="overview" element={<OverviewPage />} />
          </Route>

          <Route
            path="/rewrite-optimize-content"
            element={<RewriteOptimizeContent />}
          />

          <Route path="/meta-tags-generator" element={<MetaTagsGenerator />} />
          <Route path="/hooks-generator" element={<HooksGenerators />} />
          <Route path="/faqs-generator" element={<FaqsGenerator />} />
          <Route path="/density-checker" element={<KeywordDensityChecker />} />
          <Route path="/hashtag-generator" element={<HashtagGenerator />} />
          <Route path="/blog-generator" element={<BlogPostForm />} />
          <Route path="/broken-link-checker" element={<BrokenLinkChecker />} />
          <Route
            path="/seo-graded-content-analyzer"
            element={<SeoContentGraderAnalyzer />}
          />
          <Route
            path="/social-headlines-generator"
            element={<SocialHeadlinesGenerator />}
          />
          <Route path="/jpg-to-png-convert" element={<JpgToPngConverter />} />
          <Route path="/password-generator" element={<PasswordGenerator />} />
          <Route path="/word-counter" element={<WordCounterTool />} />
          <Route path="/robots_validate" element={<RobotsValidator />} />
          <Route
            path="/sero-preview-simulator"
            element={<SerpPreviewSimulator />}
          />
          <Route path="/color-picker" element={<ColorPicker />} />
          <Route path="/cpc-calculator" element={<CpcCalculator />} />
          <Route path="/cpm-calculator" element={<CPMCalculator />} />
          <Route path="/crc-calculator" element={<CRCCalculator />} />
          <Route path="/ctr-calculator" element={<CtrCalculator />} />
          <Route
            path="/heading-tags-checker"
            element={<HeadingTagsChecker />}
          />
          <Route
            path="/image-format-converter"
            element={<ImageFormateConverter />}
          />
          <Route path="/image-optimizer" element={<ImageOptimizer />} />
          <Route
            path="/reverse-image-search"
            element={<ReverseImageSearch />}
          />
          <Route path="/http-status-tool" element={<HttpStatusTool />} />
          <Route
            path="/marketing-roi-calculator"
            element={<MarketingRoiCalculator />}
          />
          <Route path="/redirect-checker" element={<RedirectChecker />} />
          <Route path="/roas-calculator" element={<RoasCalculator />} />
          <Route path="/domain-checker" element={<DomainChecker />} />
          <Route path="/page-speed-checker" element={<PageSpeedChecker />} />

          <Route path="/hex-to-rgb" element={<ColorConverter />} />
          <Route path="/outline-generator" element={<OutlineGenerator />} />

          <Route path="/site-map-checker" element={<SitemapChecker />} />
          <Route path="/site-map-validator" element={<SitemapValidator />} />

          <Route
            path="/robots-txt-generator"
            element={<RobotsTxtGenerator />}
          />
          <Route
            path="/website-authority-checker"
            element={<WebsiteAuthorityChecker />}
          />
          <Route path="/backlink-checker" element={<BacklinkChecker />} />
        </Routes>
      </>
    </Container>
  );
};

export default App;
